module.exports = __webpack_public_path__ + "assets/img/mecha-04d9bb44.png";